/**
 * Listing tile Add to cart / Buy it now.
 * Buy it now adds the first available variant, then goes to checkout.
 */
(function () {
  "use strict";
  if (window.__B1_LISTING_CART__) return;
  window.__B1_LISTING_CART__ = true;

  function jsonFetch(url, options) {
    return fetch(url, options).then(function (res) {
      return res.json().then(function (body) {
        if (!res.ok) {
          throw new Error((body && (body.description || body.message)) || "unavailable");
        }
        return body;
      });
    });
  }

  function addVariant(variantId) {
    return jsonFetch("/cart/add.js", {
      method: "POST",
      headers: { "Content-Type": "application/json", Accept: "application/json" },
      body: JSON.stringify({ items: [{ id: Number(variantId), quantity: 1 }] })
    });
  }

  function refreshCartDot() {
    jsonFetch("/cart.js", { headers: { Accept: "application/json" } })
      .then(function (cart) {
        var count = cart && cart.item_count ? cart.item_count : 0;
        var dots = document.querySelectorAll(".site-header__cart-indicator");
        var i;
        for (i = 0; i < dots.length; i++) {
          dots[i].textContent = count > 0 ? String(count) : "0";
          if (count > 0) dots[i].classList.remove("hide");
          else dots[i].classList.add("hide");
        }
        var link = document.querySelector(".site-header__cart");
        if (link) {
          link.setAttribute(
            "aria-label",
            "Cart, " + count + (count === 1 ? " item" : " items")
          );
        }
      })
      .catch(function () {});
  }

  function announce(ok, message) {
    try {
      if (window.theme && window.theme.Notify && typeof window.theme.Notify.open === "function") {
        window.theme.Notify.open(ok ? "success" : "error", message || false, true);
        return;
      }
    } catch (e) {}
    var live = document.querySelector("[data-b1-listing-toast]");
    if (!live) {
      live = document.createElement("div");
      live.className = "b1-listing-toast";
      live.setAttribute("data-b1-listing-toast", "");
      live.setAttribute("role", "status");
      document.body.appendChild(live);
    }
    live.textContent = message || (ok ? "Added to cart" : "Unable to add this part");
    live.classList.add("is-on");
    window.clearTimeout(announce._t);
    announce._t = window.setTimeout(function () {
      live.classList.remove("is-on");
    }, 2800);
  }

  function run(btn, goCheckout) {
    var variantId = btn.getAttribute("data-variant-id");
    var productUrl = btn.getAttribute("data-product-url") || "";
    if (!variantId || btn.disabled) return;
    btn.disabled = true;
    var original = btn.textContent;
    btn.textContent = goCheckout ? "Buying…" : "Adding…";
    addVariant(variantId)
      .then(function () {
        if (goCheckout) {
          window.location.href = "/checkout";
          return;
        }
        btn.textContent = "Added";
        announce(true, "Added to cart");
        refreshCartDot();
        window.setTimeout(function () {
          btn.textContent = original;
          btn.disabled = false;
        }, 1200);
      })
      .catch(function (err) {
        var message = err && err.message ? err.message : "";
        btn.textContent = original;
        btn.disabled = false;
        if (/already in your cart/i.test(message)) {
          announce(false, message);
          refreshCartDot();
          return;
        }
        announce(false, "Open the part to choose options");
        if (productUrl) window.location.href = productUrl;
      });
  }

  document.addEventListener("click", function (event) {
    var buy = event.target.closest("[data-b1-buy-now]");
    var add = event.target.closest("[data-b1-add-cart]");
    if (!buy && !add) return;
    event.preventDefault();
    event.stopPropagation();
    run(buy || add, Boolean(buy));
  });

  if (document.readyState === "loading") {
    document.addEventListener("DOMContentLoaded", refreshCartDot);
  } else {
    refreshCartDot();
  }
})();
